/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 65 41',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M0 40.5h64.98M46.74 20.5H65M.02 20.5h36.25M.02.5H65"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/menu.js